export default {"src":"/_next/static/media/DareDropIcon.03582295.svg","height":25,"width":25};